/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open-source access is another reason to evaluate it: a developer can inspect the project and its documented limitations. That is useful context, but it is not evidence that a particular calculation is correct. Verify results with a small example before moving a recurring task.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源也是值得评估的因素：开发者可以查看项目实现及其已记录的限制。但这并不能证明某个具体计算一定正确。在迁移日常任务前，应先用小型示例验证结果。`)
};

/**
* | output |
* | --- |
* | "Open-source access is another reason to evaluate it: a developer can inspect the project and its documented limitations. That is useful context, but it is no..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_1_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_1_paragraphs_1 as "gc.search_guides.gridcraft_vs_excel.sections.1.paragraphs.1" }